import React, { useContext } from "react"
import { StoreContext } from "../../../context/store"
import { minicart } from "./minicart.module.css"
const MiniCart = () => {
  const { cartOpen, setCartOpen, cart } = useContext(StoreContext)
  return (
    <div
      className={`${minicart}  ${
        !cartOpen && cart.length > 0
          ? "translate-y-0"
          : "translate-y-12 ease-in"
      } `}
    >
      <button
        className="  rounded-sm shadow-lg shadow-primary/30"
        onClick={() => setCartOpen(true)}
      >
        {" "}
        <span className="p-2 bg-white rounded-sm text-black border">
          {cart.length} Item{cart.length > 1 ? "s" : ""}{" "}
        </span>{" "}
        <span className="p-2 bg-primary text-white border ">
          View/Edit Cart{" "}
        </span>
      </button>
    </div>
  )
}

export default MiniCart
